import { createContext } from '@lit/context';
export const ApplicationContextToken = createContext(Symbol('ApplicationContextToken'));
//# sourceMappingURL=application-context-token.js.map